import harnessCodes from "./harnessCodes.json";

/** What one intelligent harness code stands for. */
export interface HarnessCode {
  code: number;
  /** What the harness is used for, or what it connects to. */
  use: string;
  partNumber: string;
}

/**
 * The intelligent harness codes, as reported by "Intelligent harness type detected".
 *
 * The same in every database, so the list lives here rather than per database. Kept as a table of
 * its own in `harnessCodes.json`, one code per line, to be extended there when Geotab adds one.
 * Started from Geotab's "Harness-Code-List-Geotab.xlsx".
 */
export const HARNESS_CODES: readonly HarnessCode[] = harnessCodes;

/** The entry for a reported harness code; undefined for a value that is no whole number or not listed. */
export function findHarnessCode(value: number | string | undefined): HarnessCode | undefined {
  const code = Number(value);
  return Number.isInteger(code) ? HARNESS_CODES.find(entry => entry.code === code) : undefined;
}
